import React, { useState, useCallback, ReactElement, useEffect } from 'react';
import { Modal, Popover, useBreakpoints } from '@shopify/polaris';
import type { PopoverProps } from '@shopify/polaris';

interface ResponsivePopoverProps {
  children: ReactElement<{ onClose: (...args: any[]) => void }>;
  activator: ReactElement;
  active?: boolean;
  title: string;

  /**
   * (MỚI) Callback TÙY CHỌN,
   * được gọi BẤT CỨ KHI NÀO popover/modal đóng.
   */
  onClose?: () => void;

  preferredPosition?: PopoverProps['preferredPosition'];
  autofocusTarget?: PopoverProps['autofocusTarget'];
  preventCloseOnChildOverlayClick?: boolean;
}

export function ResponsivePopover({
  children,
  activator,
  title,
  onClose, // 1. NHẬN PROP 'onClose' TỪ CHA
  preferredPosition = 'below',
  autofocusTarget,
  preventCloseOnChildOverlayClick,
  active = undefined,
}: ResponsivePopoverProps) {
  const [activePop, setActivePop] = useState(false);
  const { smUp } = useBreakpoints();
  const isDesktop = smUp;

  useEffect(() => {
    setActivePop(active);
  }, [active]);

  // 2. TẠO HÀM 'handleClose' MỚI
  // Hàm này sẽ đóng state nội bộ VÀ gọi prop 'onClose' của cha
  const handleClose = useCallback(() => {
    setActivePop(false);
    if (onClose) {
      onClose(); // Gọi ra ngoài cho cha nếu có
    }
  }, [onClose]); // Thêm 'onClose' vào dependency

  const toggleActive = useCallback(() => setActivePop((prev) => !prev), []);

  const trigger = React.cloneElement(activator, {
    onClick: toggleActive,
  });

  // 3. NÂNG CẤP LOGIC CLONE CHILDREN

  // Lấy hàm 'onClose' GỐC từ children (ví dụ: hàm có chứa 'addNewDriverCallback')
  const childOnClose = children.props.onClose;

  // Tạo một hàm 'onClose' MỚI để tiêm vào
  const handleChildClose = useCallback(
    (...args: any[]) => {
      // 3a. Gọi hàm 'onClose' GỐC trước (với đầy đủ tham số)
      if (childOnClose) {
        childOnClose(...args);
      }
      // 3b. Sau khi hàm gốc chạy xong, gọi hàm đóng của chúng ta
      handleClose();
    },
    [childOnClose, handleClose]
  );

  // Tiêm hàm 'handleChildClose' mới vào 'children'
  const content = React.cloneElement(children, {
    onClose: handleChildClose,
  });

  // 4. Render
  if (isDesktop) {
    return (
      <Popover
        active={activePop}
        activator={trigger}
        onClose={handleClose} // Dùng hàm mới
        preferredPosition={preferredPosition}
        autofocusTarget={autofocusTarget}
        preventCloseOnChildOverlayClick={preventCloseOnChildOverlayClick}
      >
        {content}
      </Popover>
    );
  }

  return (
    <>
      {trigger}
      <Modal
        open={activePop}
        onClose={handleClose} // Dùng hàm mới
        title={title}
        size="fullScreen"
      >
        {content}
      </Modal>
    </>
  );
}

